import { StateInterface } from "./state";
import { LicenseModel } from "../models";

export const setCurrentLicenseHandle = "setCurrentLicense";

export default {
  [setCurrentLicenseHandle](
    state: StateInterface,
    license: LicenseModel
  ): void {
    state.current = license;
  }
};
